import { ResponseDocumentListItem } from '@/schema'

import { TflDocumentMetadata, TflKind, TflMeta, TflStatus } from './types'

export class TFLUtils {
  static normalizeTFLKind(kind?: string): TflKind {
    if (!kind) return TflKind.TABLE

    const normalized = kind.toLowerCase()
    switch (normalized) {
      case 'table':
        return TflKind.TABLE
      case 'figure':
        return TflKind.FIGURE
      case 'listing':
        return TflKind.LISTING
      default:
        return TflKind.TABLE
    }
  }

  static normalizeTFLStatus(status?: string): TflStatus {
    if (!status) return TflStatus.NEW

    const normalized = status.toLowerCase().replace(/\s+/g, '_') // NOSONAR - replace spaces with underscores
    switch (normalized) {
      case 'new':
        return TflStatus.NEW
      case 'in_review':
      case 'in review':
        return TflStatus.IN_REVIEW
      case 'approved':
        return TflStatus.APPROVED
      case 'query_raised':
      case 'query raised':
        return TflStatus.QUERY_RAISED
      case 'under_revision':
      case 'under revision':
        return TflStatus.UNDER_REVISION
      default:
        return TflStatus.NEW
    }
  }

  static mappingFromTOCItem(item: ResponseDocumentListItem): Partial<TflMeta> {
    const kind = this.normalizeTFLKind(item.document_type)
    const status = this.normalizeTFLStatus(item.status)

    return {
      id: item.document_id,
      displayName: item.display_name,
      fileName: item.filename,
      status,
      kind,
      documentType: item.document_type,
      version: item.latest_version_number,
      is_bookmarked: item.is_bookmarked,
    }
  }

  static mappingFromDetailMetadata(apiData: TflDocumentMetadata): TflMeta {
    const kind = this.normalizeTFLKind(apiData.document_type)
    const status = this.normalizeTFLStatus(apiData.status)

    return {
      id: apiData.document_id,
      dsId: apiData.deliverable_set_id,
      displayName: apiData.display_name,
      fileName: apiData.filename,
      status,
      kind,
      signedUrl: apiData.signed_blob_url,
      version: apiData.version_number,
      version_id: apiData.version_id,
      expiresAt: apiData.expires_at,
      reviewers: apiData.reviewers,
      created_by: apiData.created_by,
      owner: apiData.owner,
      is_bookmarked: apiData.is_bookmarked,
    }
  }
}
